module.exports = __webpack_public_path__ + "img/gitlab.9214c301.svg";